import { createAction, createRequestTypes, createRequestActions } from './utils';
import keyMirror from 'react-utils/keyMirror';
import MessageSettings from '../records/MessageSettings';
export const MessageSettingsActionTypes = keyMirror({
  LOAD_MESSAGE_SETTINGS: null,
  UPDATE_MESSAGE_SETTINGS: null,
  CLEAR_MESSAGE_SETTINGS: null
});
export const FETCH_MESSAGE_SETTINGS = 'FETCH_MESSAGE_SETTINGS';
export const UPDATE_MESSAGE_SETTINGS = 'UPDATE_MESSAGE_SETTINGS';
export const CLEAR_MESSAGE_SETTINGS = 'CLEAR_MESSAGE_SETTINGS';
export const FetchMessageSettingsActionTypes = createRequestTypes(FETCH_MESSAGE_SETTINGS);
export const FetchMessageSettings = createRequestActions(FetchMessageSettingsActionTypes);
export const loadMessageSettings = () => createAction(MessageSettingsActionTypes.LOAD_MESSAGE_SETTINGS, {
  data: {
    hubless: false
  }
});
export const UpdateMessageSettingsActionTypes = createRequestTypes(UPDATE_MESSAGE_SETTINGS);
export const UpdateMessageSettings = createRequestActions(UpdateMessageSettingsActionTypes);
export const updateMessageSettings = meetingsLinkId => createAction(MessageSettingsActionTypes.UPDATE_MESSAGE_SETTINGS, {
  data: {
    meetingsLinkId
  }
});
export const ClearMessageSettingsActionTypes = createRequestTypes(CLEAR_MESSAGE_SETTINGS);
export const ClearMessageSettings = createRequestActions(ClearMessageSettingsActionTypes);
export const clearMessageSettings = () => createAction(MessageSettingsActionTypes.CLEAR_MESSAGE_SETTINGS, {
  data: new MessageSettings()
});